'use client'
import Image from 'next/image';
import Link from 'next/link';
import React from 'react'
import { MdArrowLeft, MdArrowRight } from 'react-icons/md';

const BestSellers = ({ productsData }: {
    productsData: {
        id: number;
        sectiontype: string;
        topheader: string;
        titlename: string;
        bottomheader: string;
        action: string;
        actionlink: string;
        imageurl: string;
        isactive: number;
    }[];
}) => {
    const colors = [
        { uid: "masala", bg: "bg-[#173B58]", txt: "text-[#173B58]" },
        { uid: "elaichi", bg: "bg-[#758444]", txt: "text-[#758444]" },
        { uid: "adrak", bg: "bg-[#977352]", txt: "text-[#977352]" },
        { uid: "kadak", bg: "bg-[#551013]", txt: "text-[#551013]" },
        { uid: "kesar", bg: "bg-[#6C1D4E]", txt: "text-[#6C1D4E]" },
        { uid: "haldi", bg: "bg-[#F58937]", txt: "text-[#F58937]" },
    ]
    const [activeIndex, setActiveIndex] = React.useState(0);
    return (
        <section
            className={`w-full flex flex-col items-center justify-center py-8 ${colors.find((color) => color.uid === productsData[activeIndex]?.action?.split(" ")[1].toLowerCase())?.bg}`}
        >
            <div
                className="w-[94%] max-w-[1440px] mx-auto grid md:grid-cols-2 grid-cols-1 justify-center items-center gap-8 rounded-lg py-8 overflow-hidden relative p-4">
                <div className='w-full'>
                    <h4 className="text-3xl max-md:text-xl font-bold text-white">
                        Our Best Premixes
                    </h4>
                    <p className="text-xl max-md:text-lg text-slate-200 font-medium mt-8">
                        {productsData[activeIndex].topheader}
                    </p>
                    <h2
                        className={`lg:text-6xl text-4xl max-sm:text-2xl font-bold text-white`
                        }
                    >
                        {productsData[activeIndex].titlename}
                    </h2>
                    <p className="text-xl max-md:text-lg text-slate-200 font-medium mb-8">
                        {productsData[activeIndex].bottomheader}
                    </p>
                    <Link href={productsData[activeIndex].actionlink} className={`text-lg max-md:hidden text-white px-4 py-2 rounded-lg bg-[#0000005f]`}>
                        {productsData[activeIndex].action}
                    </Link>
                </div>
                <div className='w-full relative'>
                    {/* max-md bottom image overlay */}
                    <div className="absolute md:hidden rounded-xl bottom-0 left-0 w-full h-1/2 bg-gradient-to-t from-black to-transparent" ></div>
                    <Image
                        src={productsData[activeIndex].imageurl}
                        alt={productsData[activeIndex].titlename}
                        width={500}
                        height={500}
                        className="rounded-xl w-full h-auto max-h-[500px] object-cover object-center"
                    />
                    <Link href={productsData[activeIndex].actionlink} className={`text-lg absolute bottom-4 left-1/2 -translate-x-1/2 md:hidden text-white px-4 py-2 rounded-lg text-nowrap ${colors.find((color) => color.uid === productsData[activeIndex].action?.split(" ")[1].toLowerCase())?.bg
                        }`}
                    >
                        {productsData[activeIndex].action}
                    </Link>
                    <button onClick={() => setActiveIndex((prevIndex) => {
                        if (prevIndex === 0) {
                            return productsData.length - 1;
                        }
                        return prevIndex - 1;
                    })} className={`text-3xl absolute top-1/2 left-0 transform -translate-y-1/2 ${colors.find((color) => color.uid === productsData[activeIndex].action?.split(" ")[1].toLowerCase())?.txt
                        }`}>
                        <MdArrowLeft size={40} />
                    </button>
                    <button onClick={() => setActiveIndex((prevIndex) => {
                        if (prevIndex === productsData.length - 1) {
                            return 0;
                        }
                        return prevIndex + 1;
                    })} className={`text-3xl absolute top-1/2 right-0 transform -translate-y-1/2 ${colors.find((color) => color.uid === productsData[activeIndex].action?.split(" ")[1].toLowerCase())?.txt
                        }`}>
                        <MdArrowRight size={40} />
                    </button>
                </div>
            </div>
        </section>
    )
}

export default BestSellers